import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortbyLanguage',
})
export class SortByLanguagePipe implements PipeTransform {
  transform(value: Array<any>, ...args: string[]): unknown {
    const [lang] = args;
    if (!value) {
      return;
    }
    const data = value.filter((el) => el.language === lang);
    return data.length ? data : [value[0]];
  }
}
